<template>
  <header>
    <button v-if="isMobile" @click="_onContextButtonClick" class="context-button">
      <svg :class="{ 'expanded': !contextSlotHidden }" xmlns="http://www.w3.org/2000/svg" width="18" height="8"><path d="M16.349.001L9 5.52 1.65.001 0 1.241l9 6.76 9-6.76z" fill-rule="evenodd"/></svg>
    </button>
    <h1>FontSpark</h1>
    <button @click="_onMenuButtonClick" class="menu-button">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="8"><g><path d="M0 6h18v2H0z"/><path d="M0 0h18v2H0z"/></g></svg>
    </button>
  </header>
</template>

<script>
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'app-header',
    computed: {
      ...mapState('ui', [
        'isMobile',
        'fontPreviewHasInput',
        'contextSlotHidden'
      ])
    },
    methods: {
      ...mapActions('ui', [
        'toggleSidebar',
        'setContextSlotState'
      ]),
      _onMenuButtonClick() {
        this.toggleSidebar();
      },
      _onContextButtonClick() {
        this.setContextSlotState(!this.contextSlotHidden);
      }
    }
  }
</script>

<style lang="scss" scoped>
  header {
    width: 100%;
    height: 3.5rem;
    position: fixed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    border-bottom: 1px solid #ddd;
    padding: 0 3rem;
    z-index: 30;

    @media (max-width: 40rem) {
      padding: 0 1.5rem;
    }

    .app.dark & {
      background: #000;
      border-color: #0E0E10;
    }
  }

  h1 {
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    margin: 0;
  }

  .context-button svg {
    transition: all 500ms ease-in-out;

    &.expanded {
      transform: rotate3d(1,0,0,180deg);
    }
  }

  .app.dark .menu-button svg path {
    fill: #fff;
  }
  
</style>
